
































































































































































import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import UserCompaniesMixin from '@/mixins/UserCompaniesMixin.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import SaveButton from '@/components/SaveButton.vue'
import LabeledValue from '@/components/LabeledValue.vue'
import ProductSelector from '@/components/Order/ProductSelector.vue'
import QuantityTypeSelector from '@/components/Order/QuantityTypeSelector.vue'
import QuantityComboBox from '@/components/QuantityComboBox.vue'
import {
  Company,
  CompanyTypeEnum,
  ICategorySetting,
  IVendorSetting,
  PriceList,
  PriceListCollection,
  QuickbooksSetting,
  QuickbooksSettingCollection
} from 'serverless-firestore'

@Component({
  components: {
    SaveButton,
    LoadingPage,
    LabeledValue,
    ProductSelector,
    QuantityTypeSelector,
    QuantityComboBox
  }
})
export default class QuickbooksSettings extends Mixins(IconsMixin, AuthMixin, UserCompaniesMixin) {
  public isLoading: boolean = false
  public quickbooksSetting: QuickbooksSetting = {} as QuickbooksSetting
  public errors: string[] = []
  public displayHelperText: boolean = false
  public isSaving: boolean = false
  public vendors: Company[] = []
  public priceLists: PriceList[] = []
  public tabs = null

  //METHODS
  public async mounted() {
    this.isLoading = true
    const quickbooksSettingCollection = new QuickbooksSettingCollection(( await this.$firebase ).firestore())
    const quickbooksSetting = await quickbooksSettingCollection.getQuickbooksSettingByRestaurantCompanyId(this.userCompany.id)
    if (quickbooksSetting) {
      this.quickbooksSetting = quickbooksSetting
    } else {
      this.quickbooksSetting = new QuickbooksSetting(this.userCompany.id)
      this.displayHelperText = true
    }

    if (!this.quickbooksSetting.categorySettings) {
      this.quickbooksSetting.categorySettings = {} as ICategorySetting
    }

    const priceListCollection = new PriceListCollection(( await this.$firebase ).firestore())
    const priceLists = await priceListCollection.listPriceListsByCompanyId(
      this.userCompany.id,
      CompanyTypeEnum.RESTAURANT,
      true
    )

    if (priceLists) {
      this.priceLists = priceLists

      this.quickbooksSetting.vendorSettings = this.priceLists.reduce((acc, priceList) => {
          const vendorSetting = this.quickbooksSetting.vendorSettings
            && this.quickbooksSetting.vendorSettings[priceList.vendorCompanyId]
              ? this.quickbooksSetting.vendorSettings[priceList.vendorCompanyId]
              : null

          return {
            ...acc,
            [priceList.vendorCompanyId]: {
              quickbooksVendorName: vendorSetting && vendorSetting.quickbooksVendorName
                ? vendorSetting.quickbooksVendorName
                : '',
              quickbooksExpenseAccount: vendorSetting && vendorSetting.quickbooksExpenseAccount
                ? vendorSetting.quickbooksExpenseAccount
                : ''
            }
          }
        }, {} as IVendorSetting
      )
    }

    this.isLoading = false
  }

  public async save() {
    // console.log(JSON.parse(JSON.stringify(this.quickbooksSetting)));

    this.isSaving = true
    const quickbooksSettingCollection = new QuickbooksSettingCollection(( await this.$firebase ).firestore())
    // maybe filter out all blank vendor settings?
    await quickbooksSettingCollection.save(this.quickbooksSetting)
    this.isSaving = false
    // this.$router.go(0)
  }
}
